import { Header, InnerSidebar, InnerSidebarItem } from "@aurem/components";
import { useI18n } from "providers/I18nProvider";
import { useBasePath } from "../../../hooks/useBasePath";
import { getAllInternalResources } from "../../../lib/internal-resources";

export const InternalDataSidebar = () => {
  const { t } = useI18n();
  const { path } = useBasePath();

  const resources = getAllInternalResources().sort(
    (a, b) => a.navigation.order - b.navigation.order,
  );

  const header = (
    <Header>
      <h1 className="font-medium">{t("apps.admin.navBar.subNavBar.data")}</h1>
    </Header>
  );

  return (
    <InnerSidebar header={header}>
      {resources.map((resource) => (
        <InnerSidebarItem
          key={resource.resourceName}
          to={path(resource.basePath)}
          label={t(resource.displayNameKey)}
        />
      ))}
    </InnerSidebar>
  );
};
